module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": "登录",
      "visible": _vm.dlFormVisible,
      "custom-class": "dialog-t",
      "width": "300px",
      "before-close": _vm.clearDl
    },
    on: {
      "update:visible": function($event) {
        _vm.dlFormVisible = $event
      }
    }
  }, [_c('login', {
    ref: "login",
    attrs: {
      "type": 2
    },
    on: {
      "showlogin": _vm.showDialog,
      "showregist": _vm.showRegist
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460897aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginDialog/loginDialog.vue
// module id = 628
// module chunks = 31